import React from "react";
import { Span, SpanProps } from "@catchoftheday/cg-components";

export const AvailabilityTag: React.FC<SpanProps> = ({
  children,
  ...props
}) => {
  if (!children) {
    return null;
  }

  return (
    <Span
      textTransform="uppercase"
      color={"#FFF"}
      lineHeight="1"
      display="inline-block"
      fontWeight="semibold"
      marginLeft="6px"
      padding="4px 5px"
      textAlign="center"
      marginBottom={{ xs: "6px", sm: "5px" }}
      fontSize="2xs"
      {...props}
    >
      {children}
    </Span>
  );
};
